module.exports = __webpack_public_path__ + "media/images/flags/64/North-Korea-a9a3f34195e1ae5d9deeb7732b021734.png";